import React, { useContext, useEffect, useState } from 'react';
import DisplayApprovedOfferLetter from '../../../Forms/loan/DisplayApprovedOfferLetter';
import { ContextData } from '../../../../../../../context/Context';
import { Getrequest } from '../../../../../../../context/AxiosRequest';
import DisplayApprovedOfferLetterThirdParty from '../../../Forms/loan/DisplayApprovedOfferLetterThirdParty';

const FinalOffer = () => {

        const { UserTokens, accesstoken } = useContext(ContextData);
           const [ChangeLoanForm, setChangeLoanForm] = useState(null);

        useEffect(()=>{


            (async()=>{


               
               const loanData = await Getrequest(`/auth/get_loan_data/${UserTokens}`,accesstoken);
              if(loanData) setChangeLoanForm(loanData?.loanrequest[0]?.loan_category);






            })()




        },[UserTokens])

    return (
        <div>
            {
                ChangeLoanForm !==  null &&

                <>
                 {
                    ChangeLoanForm === "thirdparty" ?
                     <DisplayApprovedOfferLetterThirdParty from="thirdparty_applicant" user_tokens={UserTokens} accesstoken={accesstoken} />
                     :
                    <DisplayApprovedOfferLetter from="applicant" user_tokens={UserTokens} accesstoken={accesstoken} />   
                 }
                </>
            }
         
           
        </div>
    );
}

export default FinalOffer;
